export default "__VITE_ASSET__ySb9a4q5__"